import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch } from 'utils/http'

const updatePaymentMethod = async ({ customerId, paymentMethod }: any) => {
  return patch(`/management/customers/${customerId}`, { payment_method: paymentMethod })
}

export const useCustomerPaymentMethodUpdate = () => {
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  return useMutation({
    mutationFn: updatePaymentMethod,
    onSuccess: async (_data, { customerId }: any) => {
      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
      addNotification('Payment method successfully changed')
    },
  })
}
